import EmptyState from 'hb-builder/components/common/state/EmptyState';
import ExclamationMark from 'hb-react/shared/icons/ExclamationMark';

const ErrorState = ({ error }) => {
  const { data: errorText } = error.response || {};

  return (
    <EmptyState height="300px">
      <ExclamationMark height={20} width={20} style={{ marginRight: '4px' }} />
      {errorText}
    </EmptyState>
  );
};

export default ErrorState;
